export default [
  {
    Companies: [
      {
        fileName: "login/companii/up-cultura-scoala.png",
        link:
        "https://upromania.ro/companii/card-cultural/",
        category: "Banner",
        action: "Click",
        label: "Companii_cultura_scoala",
      },
      {
        fileName: "login/companii/banner_recomanda_2.png",
        link:
          "https://upromania.ro/recomanda/?utm_source=uponline&utm_medium=banner&utm_campaign=Recomanda",
        category: "Banner",
        action: "Click",
        label: "Companii_Recomanda",
      },
      {
        fileName: "login/companii/vn-dejun.png",
        link: "https://upromania.ro/utile/legislatie/ordin-484-280-2025/",
        category: "Banner",
        action: "Click",
        label: "Client_vn_dejun",
      },
      // {
      //   fileName: "login/companii/up-cultura-up-onlline.png",
      //   link:
      //   "https://upromania.ro/companii/card-cultural/",
      //   category: "Banner",
      //   action: "Click",
      //   label: "Companii_cultura_VN220",
      // },
      {
        fileName: "login/companii/up-vacanta-up-online.png",
        link: "https://catalogulcuvacante.ro/b2c/#/up/catalogs",
        category: "Banner",
        action: "Click",
        label: "Companii_ConfigVacante",
      },
    ],
    Beneficiaries: [
      {
        fileName: "login/companii/banner_recomanda_2.png",
        link: "https://upromania.ro/recomanda/",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriRecomandaCastiga",
      },
      {
        fileName: "login/utilizatori/banner_mobilplus.png",
        link:
          "https://upromania.page.link/ump",
        category: "Banner",
        action: "Click",
        label: "Utilizatori_mobilplus",
      },
      {
        fileName: "login/utilizatori/banner_blenche.png",
        link:
          "https://www.youtube.com/watch?v=Yeo8EFuJ0TM",
        category: "Banner",
        action: "Click",
        label: "Utilizatori_blenche",
      },
      {
        fileName: "login/utilizatori/banner_sezamo.png",
        link:
          "",
        category: "Banner",
        action: "Click",
        label: "Utilizatori_sezamo",
      }, 
    ],
  },
];
